//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Create analysis preset for study
 */
export function createAnalysisPreset(dto: Types.AnalysisPresetCreationDto, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisPresetDto> {
    let url_ = getBaseUrl() + "/api/analyzes/presets";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateAnalysisPreset,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateAnalysisPreset(_response);
    });
}

function processCreateAnalysisPreset(response: AxiosResponse): Promise<Types.AnalysisPresetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnalysisPresetDto.fromJS(resultData200);
        return Promise.resolve<Types.AnalysisPresetDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisPresetDto>(null as any);
}

/**
 * Get all analysis presets for study
 * @param studyId (optional) 
 */
export function getAllAnalysisPresetsForStudy(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisPresetDto[]> {
    let url_ = getBaseUrl() + "/api/analyzes/presets?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAllAnalysisPresetsForStudy,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAllAnalysisPresetsForStudy(_response);
    });
}

function processGetAllAnalysisPresetsForStudy(response: AxiosResponse): Promise<Types.AnalysisPresetDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.AnalysisPresetDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.AnalysisPresetDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisPresetDto[]>(null as any);
}

/**
 * Update analysis preset for study
 */
export function updateAnalysisPreset(id: number, dto: Types.AnalysisPresetUpdateDto, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisPresetDto> {
    let url_ = getBaseUrl() + "/api/analyzes/presets/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateAnalysisPreset,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateAnalysisPreset(_response);
    });
}

function processUpdateAnalysisPreset(response: AxiosResponse): Promise<Types.AnalysisPresetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnalysisPresetDto.fromJS(resultData200);
        return Promise.resolve<Types.AnalysisPresetDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisPresetDto>(null as any);
}

/**
 * Remove analysis by ID
 */
export function deleteAnalysisPreset(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/analyzes/presets/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteAnalysisPreset,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteAnalysisPreset(_response);
    });
}

function processDeleteAnalysisPreset(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get analysis preset by ID
 */
export function getAnalysisPresetById(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisPresetDto> {
    let url_ = getBaseUrl() + "/api/analyzes/presets/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAnalysisPresetById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAnalysisPresetById(_response);
    });
}

function processGetAnalysisPresetById(response: AxiosResponse): Promise<Types.AnalysisPresetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnalysisPresetDto.fromJS(resultData200);
        return Promise.resolve<Types.AnalysisPresetDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisPresetDto>(null as any);
}

/**
 * Attach analysis to patient
 * @param patientId (optional) 
 */
export function createAnalysis(dto: Types.AnalysisCreationDto, patientId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisDto> {
    let url_ = getBaseUrl() + "/api/analyzes?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateAnalysis,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateAnalysis(_response);
    });
}

function processCreateAnalysis(response: AxiosResponse): Promise<Types.AnalysisDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnalysisDto.fromJS(resultData200);
        return Promise.resolve<Types.AnalysisDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisDto>(null as any);
}

/**
 * Get all patient's analyzes
 * @param patientId (optional) 
 * @param presetId (optional) 
 */
export function getAllPatientAnalyzes(patientId?: string | undefined, presetId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisDto[]> {
    let url_ = getBaseUrl() + "/api/analyzes?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
    if (presetId !== undefined && presetId !== null)
        url_ += "presetId=" + encodeURIComponent("" + presetId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAllPatientAnalyzes,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAllPatientAnalyzes(_response);
    });
}

function processGetAllPatientAnalyzes(response: AxiosResponse): Promise<Types.AnalysisDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.AnalysisDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.AnalysisDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisDto[]>(null as any);
}

/**
 * Remove analysis by ID
 */
export function deleteAnalysis(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/analyzes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteAnalysis,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteAnalysis(_response);
    });
}

function processDeleteAnalysis(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get analysis by ID
 */
export function getAnalysisById(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.AnalysisDto> {
    let url_ = getBaseUrl() + "/api/analyzes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAnalysisById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAnalysisById(_response);
    });
}

function processGetAnalysisById(response: AxiosResponse): Promise<Types.AnalysisDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AnalysisDto.fromJS(resultData200);
        return Promise.resolve<Types.AnalysisDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AnalysisDto>(null as any);
}
let _requestConfigCreateAnalysisPreset: Partial<AxiosRequestConfig> | null;
export function getCreateAnalysisPresetRequestConfig() {
  return _requestConfigCreateAnalysisPreset;
}
export function setCreateAnalysisPresetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateAnalysisPreset = value;
}
export function patchCreateAnalysisPresetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateAnalysisPreset = patch(_requestConfigCreateAnalysisPreset ?? {});
}

let _requestConfigGetAllAnalysisPresetsForStudy: Partial<AxiosRequestConfig> | null;
export function getGetAllAnalysisPresetsForStudyRequestConfig() {
  return _requestConfigGetAllAnalysisPresetsForStudy;
}
export function setGetAllAnalysisPresetsForStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAllAnalysisPresetsForStudy = value;
}
export function patchGetAllAnalysisPresetsForStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAllAnalysisPresetsForStudy = patch(_requestConfigGetAllAnalysisPresetsForStudy ?? {});
}

let _requestConfigUpdateAnalysisPreset: Partial<AxiosRequestConfig> | null;
export function getUpdateAnalysisPresetRequestConfig() {
  return _requestConfigUpdateAnalysisPreset;
}
export function setUpdateAnalysisPresetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateAnalysisPreset = value;
}
export function patchUpdateAnalysisPresetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateAnalysisPreset = patch(_requestConfigUpdateAnalysisPreset ?? {});
}

let _requestConfigDeleteAnalysisPreset: Partial<AxiosRequestConfig> | null;
export function getDeleteAnalysisPresetRequestConfig() {
  return _requestConfigDeleteAnalysisPreset;
}
export function setDeleteAnalysisPresetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteAnalysisPreset = value;
}
export function patchDeleteAnalysisPresetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteAnalysisPreset = patch(_requestConfigDeleteAnalysisPreset ?? {});
}

let _requestConfigGetAnalysisPresetById: Partial<AxiosRequestConfig> | null;
export function getGetAnalysisPresetByIdRequestConfig() {
  return _requestConfigGetAnalysisPresetById;
}
export function setGetAnalysisPresetByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAnalysisPresetById = value;
}
export function patchGetAnalysisPresetByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAnalysisPresetById = patch(_requestConfigGetAnalysisPresetById ?? {});
}

let _requestConfigCreateAnalysis: Partial<AxiosRequestConfig> | null;
export function getCreateAnalysisRequestConfig() {
  return _requestConfigCreateAnalysis;
}
export function setCreateAnalysisRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateAnalysis = value;
}
export function patchCreateAnalysisRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateAnalysis = patch(_requestConfigCreateAnalysis ?? {});
}

let _requestConfigGetAllPatientAnalyzes: Partial<AxiosRequestConfig> | null;
export function getGetAllPatientAnalyzesRequestConfig() {
  return _requestConfigGetAllPatientAnalyzes;
}
export function setGetAllPatientAnalyzesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAllPatientAnalyzes = value;
}
export function patchGetAllPatientAnalyzesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAllPatientAnalyzes = patch(_requestConfigGetAllPatientAnalyzes ?? {});
}

let _requestConfigDeleteAnalysis: Partial<AxiosRequestConfig> | null;
export function getDeleteAnalysisRequestConfig() {
  return _requestConfigDeleteAnalysis;
}
export function setDeleteAnalysisRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteAnalysis = value;
}
export function patchDeleteAnalysisRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteAnalysis = patch(_requestConfigDeleteAnalysis ?? {});
}

let _requestConfigGetAnalysisById: Partial<AxiosRequestConfig> | null;
export function getGetAnalysisByIdRequestConfig() {
  return _requestConfigGetAnalysisById;
}
export function setGetAnalysisByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAnalysisById = value;
}
export function patchGetAnalysisByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAnalysisById = patch(_requestConfigGetAnalysisById ?? {});
}